import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import WidgetHeader from '../../../UserWidgets/_partials/WidgetHeader/WidgetHeader';
import WidgetHeaderMobile from '../../../UserWidgets/_partials/WidgetHeaderMobile/WidgetHeaderMobile';
import EditGallectionButton from '../EditGallectionButton';
import SearchField from '../SearchField';
import { GallectionType } from '../../../../../types/gallection';
import { MobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import s from './FoldersHeader.scss';

export interface Props {
  gallectionType: GallectionType;
}

export const FoldersHeader: React.FC<Props> = ({ gallectionType }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  const isGallery = gallectionType === GallectionType.GALLERY;

  const header = t(
    isGallery
      ? 'pages.gallections.gallery.folders'
      : 'pages.gallections.collection.folders'
  );

  if (isMobile) {
    return <WidgetHeaderMobile header={header} />;
  }

  return (
    <WidgetHeader
      header={header}
      className={classnames(s['header'])}
      extras={
        <div className={s['header-extras']}>
          <EditGallectionButton className={s['edit-button']} />
          <SearchField className={s['flex-grow-right']} />
        </div>
      }
    />
  );
};
FoldersHeader.displayName = 'FoldersHeader';

export default FoldersHeader;
